import React, {Component} from 'react';
import {gpn} from "../../GPN"
import axios from "axios";
import config from "../../config";
import {toast} from "react-toastify";
import {Cascader} from "antd";
import PostEditor from "../sections/PostEditor";
import Fab from "../sections/Fab";
import Modal from "../sections/Modal";

class CreateProduct extends Component {

    state = {
        title: "",
        content: "",
        category: "",
        categories: [],
        images: [],
        editorState: "",
        info: [],
        meta: {
            description: "",
            keywords: ""
        },
        price: "0",
        inStock: "true",

        infoKey: "",
        infoValue: "",

        uploadModal: false,
        img: null,
        uploadUrl: "",


        keyword: ""
    };

    constructor(props) {
        super(props);
        this.infoKey = React.createRef();
        this.infoValue = React.createRef();
    }

    componentDidMount() {
        this.getCategories();
    }


    getCategories() {
        axios.get(`${config.apiV1}/product/categories`)
            .then(r => {

                window.scrollTo(0, 0);
                this.setState({
                    categories: r.data
                });
            })
            .catch(err => {
                toast.error("خطایی رخ داده است!");
            });
    }

    handleInputChange(e) {
        const {name, value} = e.target;

        this.setState({
            [name]: value
        });
    }

    handleFileChange(e) {
        const {files} = e.target;
        const arrFiles = Array.from(files);

        this.setState({
            images: arrFiles
        });

    }

    handleCategoryChange(selected) {
        let arr = selected.includes(",") ? selected.split(',') : selected;

        const category = arr;
        this.setState({
            category
        });
    }

    uploadImage(img) {
        if (img) {
            toast.success("در حال آپلود ...")
            let params = new FormData();
            params.append('img', img);

            axios.post(`${config.api}/upload/image?token=${config.token}`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(r => {
                    this.setState({uploadUrl: r.data.url});
                    toast.success("با موفقیت آپلود شد.")
                })
                .catch(err => {
                    toast.error("خطا!")
                });
        }
    }

    handleInfoSubmit(e) {
        const {infoKey, infoValue} = this.state;
        let {info} = this.state;
        info.push({
            key: infoKey,
            value: infoValue
        });
        this.setState({info, infoKey: "", infoValue: ""});
    }

    handleInfoChange(e, index) {
        let {name, value} = e.target;
        name = name === "IK" ? "key" : "value";
        let {info} = this.state;
        info[index][name] = value;
        this.setState({info});
    }

    handleSendProduct() {
        toast.success("در حال ارسال ...");
        let {title, content, category, images, info, meta, price, inStock} = this.state;

        let params = new FormData();
        params.append('title', title);
        params.append('content', content);
        params.append('category', JSON.stringify(category));
        params.append('info', JSON.stringify(info));
        params.append('meta', JSON.stringify(meta));
        params.append('price', price);
        params.append('inStock', inStock);

        images.map(img => {
            params.append('images', img);
        });

        axios.post(`${config.api}/product?token=${config.token}`, params, {
            header: {
                'content-type': 'multipart/form-data'
            }
        })
            .then(r => {
                toast.success("با موفقیت ایجاد شد.");
                setTimeout(() => {
                    this.props.navigate(-1);
                })
            })
            .catch(err => {
                toast.error("خطا!");
            });
    }

    render() {
        const {
            title,
            content,
            categories,
            images,
            uploadUrl,
            info,
            infoKey,
            infoValue,
            meta,
            keyword,
            price,
            inStock
        } = this.state;
        return (
            <div className="create-product">
                <form autoComplete="off" onSubmit={e => e.preventDefault()}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-control">
                                <label htmlFor="title">عنوان:</label>
                                <input type="text"
                                       name="title"
                                       id="title"
                                       onChange={this.handleInputChange.bind(this)}
                                       value={title}
                                       placeholder="عنوان"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-control">
                                <label htmlFor="images">تصاویر:

                                    <div className="images">
                                        {
                                            images.map((img, i) =>
                                                <img src={URL.createObjectURL(img)} key={"img" + i} alt=""/>
                                            )
                                        }
                                    </div>
                                </label>
                                <input type="file"
                                       name="images"
                                       id="images"
                                       multiple
                                       onChange={this.handleFileChange.bind(this)}
                                       accept="image/*"
                                       style={{
                                           display: images.length > 0 ? "none" : "inline-block"
                                       }}/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-control">

                                <label htmlFor="category">دسته بندی:</label>
                                <Cascader options={categories.cascaderCategories}
                                          id="category"
                                          changeOnSelect
                                          bordered={false}
                                          multiple={false}
                                          style={{width: '100%', borderBottom: "1px solid #cdcdcd"}}
                                          onChange={(e) => this.handleCategoryChange(e)}
                                          size={"large"}
                                          placement={"bottomLeft"}
                                          expandIcon={<span>&nbsp;</span>}
                                          placeholder="دسته بندی ..."/>
                            </div>
                        </div>
                        <div className="col-md-6"></div>
                        <div className="col-6">
                            <div className="form-control">
                                <label htmlFor="price">قیمت:</label>
                                <input type="number" name="price" id="price"
                                       value={price}
                                       onWheel={e => e.target.blur()}
                                       onChange={this.handleInputChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-control">
                                <label htmlFor="inStock">در انبار:</label>
                                <select name="inStock" id="inStock"
                                        onChange={(e) => {
                                            this.setState({
                                                inStock: e.target.value
                                            });
                                        }}>
                                    <option value="true">موجود</option>
                                    <option value="false">ناموجود</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-12">
                            <br/>
                            <div>مشخصات:</div>
                            <div className="add-info">
                                <div className="row">
                                    <div className="col">
                                        <div className="form-control">
                                            <label htmlFor="infoKey">مشخصه:</label>
                                            <input type="text"
                                                   name="infoKey"
                                                   id="infoKey"
                                                   ref={this.infoKey}
                                                   value={infoKey}
                                                   onChange={this.handleInputChange.bind(this)}
                                                   onKeyDown={e => {
                                                       if (e.code === "Enter") {
                                                           this.infoValue.current.focus();
                                                       }
                                                   }}
                                                   onKeyUp={e => {
                                                       if (e.ctrlKey && e.code === 'KeyV') {
                                                           this.infoValue.current.focus();
                                                       }
                                                   }}
                                                   placeholder="کلید"/>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-control">
                                            <label htmlFor="infoValue">مقدار:</label>
                                            <input type="text"
                                                   name="infoValue"
                                                   id="infoValue"
                                                   ref={this.infoValue}
                                                   value={infoValue}
                                                   onChange={this.handleInputChange.bind(this)}
                                                   onKeyDown={e => {
                                                       if (e.code === "Enter") {
                                                           this.handleInfoSubmit();
                                                           this.infoKey.current.focus();
                                                       }
                                                   }}
                                                   onKeyUp={e => {
                                                       if (e.ctrlKey && e.code === 'KeyV') {
                                                           this.handleInfoSubmit();
                                                           this.infoKey.current.focus();
                                                       }
                                                   }}
                                                   placeholder="مقدار"/>
                                        </div>
                                    </div>
                                    <div className="col-auto"><span onClick={this.handleInfoSubmit.bind(this)}>+</span>
                                    </div>
                                </div>
                            </div>
                            <br/>
                            {
                                info.map((info, i) =>
                                    <div key={"info" + i} className="info">
                                        <div className="row">
                                            <div className="col key">
                                                <input type="text"
                                                       name="IK"
                                                       id="IK"
                                                       onChange={e => this.handleInfoChange(e, i)}
                                                       value={info.key}/>
                                            </div>
                                            <div className="col value">
                                                <input type="text"
                                                       name="IV"
                                                       onChange={e => this.handleInfoChange(e, i)}
                                                       id="IV" value={info.value}/>
                                            </div>
                                            <div className="col-auto">
                                                <span onClick={() => {
                                                    let mInfo = this.state.info;
                                                    mInfo.splice(i, 1);
                                                    this.setState({
                                                        info: mInfo
                                                    });
                                                    this.infoKey.current.focus();
                                                }
                                                }>-</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            <br/><br/>
                        </div>
                        <div className="col-12">
                            <PostEditor
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                onChange={(e) => {
                                    this.setState({content: e})
                                }}
                                toolbarClassName="toolbar-class"
                            />
                        </div>
                        <div className="col-md-6">
                            <div className="form-control">
                                <label htmlFor="description">توضیحات متا:</label>
                                <textarea name="description"
                                          id="description"
                                          rows="5"
                                          value={meta.description}
                                          onChange={
                                              (e) => {
                                                  let m = meta;
                                                  m.description = e.target.value;
                                                  this.setState({meta: m})
                                              }
                                          }
                                          placeholder="توضیحات ....">

                                    </textarea>
                            </div>


                        </div>

                        <div className="col-md-6">
                            <div className="form-control">
                                <label htmlFor="keyword">کلیدواژه ها:</label>
                                <input type="text"
                                       name="keyword"
                                       id="keyword"
                                       value={keyword}
                                       onChange={this.handleInputChange.bind(this)}
                                       onKeyDown={e => {
                                           if (e.code === "Enter") {

                                               let keywordsStr = meta.keywords;
                                               keywordsStr = keywordsStr + keyword + ",";


                                               let m = meta;
                                               m.keywords = keywordsStr;

                                               this.setState({
                                                   meta: m,
                                                   keyword: ""
                                               });

                                           }
                                       }}
                                       placeholder="کلیدواژه"/>

                                <textarea value={meta.keywords}
                                          name="keywords"
                                          id="keywords"
                                          placeholder="کلیدواژه ها ....">

                                    </textarea>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <br/><br/><br/>
                            <button type="button" onClick={this.handleSendProduct.bind(this)}>ارسال
                                محصول
                            </button>
                        </div>
                    </div>
                </form>
                <Fab icon="cloud_upload" size={14} onClick={() => {
                    this.setState({
                        uploadModal: true
                    })
                }}/>
                <Modal show={this.state.uploadModal}
                       title="آپلود عکس"
                       onCloseClick={() => {
                           this.setState({
                               uploadModal: false
                           })
                       }}>
                    <div className="form-control">
                        <label htmlFor="img">عکس:</label>
                        <input type="file"
                               name="img"
                               id="img"
                               onChange={(e) => {
                                   const {files} = e.target;
                                   const arrFiles = Array.from(files);

                                   this.setState({
                                       img: arrFiles[0]
                                   });
                                   this.uploadImage(arrFiles[0])
                               }}/>
                        {
                            uploadUrl !== "" ?
                                <input type="text" name="uploadUrl" id="uploadUrl" value={uploadUrl}/>
                                : null
                        }
                    </div>
                </Modal>
            </div>
        );
    }
}

export default gpn(CreateProduct);